import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { RUTA_INICIO, useMarco } from './MarcoContext';

export default function NoEncontrada() {
  const { pathname } = useLocation();
  const { abrirPaleta } = useMarco();
  return (
    <div className="sym-vacio">
      <div className="sym-vacio__codigo">404</div>
      <h2>Pantalla no encontrada</h2>
      <p>La dirección <code>{pathname}</code> no corresponde a ninguna pantalla del sistema.</p>
      <div className="d-flex gap-2 justify-content-center">
        <Link to={RUTA_INICIO} className="btn btn-primary">Ir al inicio</Link>
        <button type="button" className="btn btn-outline-secondary" onClick={abrirPaleta}>
          Buscar pantalla <kbd className="sym-kbd ms-1">Ctrl K</kbd>
        </button>
      </div>
    </div>
  );
}
